import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { EcosystemType, PlotReportFactElement } from '@/api/rest/resources/types/fact';
import { ChartHeading } from '@/components/Charts/components/ChartHeading';
import { printLatestDate } from '@/components/NCCard/NCCard';
import { FactLinearGradient } from '@/components/NCFactCapsule/FactLinearGradient';
import { isNullish } from '@/utils/booleans';

import { NoPlotData } from '../NoPlotData';

export const EiiGraphTile = ({
  latestFact,
  eiiType = EcosystemType.terrestrial,
}: {
  latestFact: PlotReportFactElement<number>;
  eiiType: EcosystemType;
}) => {
  const { t } = useTranslation();

  if (isNullish(latestFact.value)) {
    return <NoPlotData />;
  }
  const lastMeasuredDate = printLatestDate([latestFact?.measured_at]);

  return (
    <Stack center data-testid='eii-graph-tile'>
      <Stack spacing={2.5} className='w-full items-center justify-center px-1 py-6 lg:items-start lg:p-8 lg:pl-1'>
        <ChartHeading
          heading={t(`shared.ncaDetail.details.ecosystemIntegrityIndex.labels.${eiiType}.avgEcosystemIntegrityIndex`)}
          popover={{
            title: t('shared.ncaDetail.details.ecosystemIntegrityIndex.explainers.historicalEii.title'),
            body: t('shared.ncaDetail.details.ecosystemIntegrityIndex.explainers.historicalEii.body'),
          }}
          className='w-full px-6 sm:px-0'
        />
      </Stack>
      <FactLinearGradient
        latestFact={latestFact}
        ncFactCapsuleProps={{
          label: t('shared.ncaDetail.details.labels.plotAvgValue'),
          infoPopoverProps: {
            title: t('shared.ncaDetail.details.plotAvgValue.title'),
            body: t('shared.ncaDetail.details.plotAvgValue.body', {
              date: lastMeasuredDate,
            }),
            popoverTriggerProps: {
              className: 'text-xs',
              'data-testid': 'eii-mean-tooltip',
            },
          },
        }}
      />
    </Stack>
  );
};
